/**
 * Bordered card header with a title and optional subtitle on the left, an
 * optional action on the right, and a divider below. It matches the look of the
 * coach dashboard card headers.
 */
export const CARD_HEADER_BORDER = '#E0E0E0'

export const cardHeaderStyles = theme => ({
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    borderBottom: `1px solid ${CARD_HEADER_BORDER}`,
  },
  cardTitleBlock: {
    minWidth: 0,
  },
  cardTitle: {
    color: '#172024',
    marginBottom: theme.spacing(0.25),
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
})
